// extracted by mini-css-extract-plugin
var _1 = "BirdviewChartCard-modulebody__mz7eq";
var _2 = "BirdviewChartCard-modulechart__NS6xx";
export { _1 as "body", _2 as "chart" }
